import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import Cookies from "js-cookie";

export const CookieModal = () => {
    const [showBanner, setShowBanner] = useState(false);

    const handleAcceptCookies = () => {
        Cookies.set('cookiesAccepted', 'true', { expires: 365 });
        setShowBanner(false);
    };
    const handleRejectCookies = () => {
        Cookies.set('cookiesAccepted', 'false', { expires: 7 });
        setShowBanner(false);
    };

    useEffect(() => {
        const cookiesAccepted = Cookies.get('cookiesAccepted');
        if (!cookiesAccepted) {
            setShowBanner(true);
        }
    }, [])

    return (
        <>
            {showBanner ? <>
                <div className={`cookies d-block`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9">
                                <h1 className="heading mb-4">
                                    Cookies Policy
                                </h1>
                                <p>We use cookies to enable necessary site functionality, to provide the best possible user experience, and to tailor future communications. By using this website, you agree to the use of cookies as outlined in website drona online <NavLink className='text-primary' to='/'>privacy policy</NavLink>.</p>
                                <div className='mt-4'>
                                    <button className='btn-primary btn me-3' onClick={handleAcceptCookies}>I understand</button>
                                    <button className='btn-danger btn' onClick={handleRejectCookies}>I decline</button>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <img src="./images/cookie.webp" alt="cookie" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`ovarlay d-block`}></div>
            </> : <></> }
        </>
    )
}
